// extracted by mini-css-extract-plugin
module.exports = {"container":"Subscription_container__DskW4","input":"Subscription_input__giIcS","button":"Subscription_button__0x7BY","flex1":"Subscription_flex1__e7Gjw"};